<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index)  in levelList" :key="item.path" v-if="item.meta.title">

        <span v-if="item.meta.insideURL || item.redirect==='noredirect'||index==levelList.length-1" class="no-redirect">{{item.meta.title}}</span>

        <router-link v-else :to="item.redirect||item.path">{{item.meta.title}}</router-link>

      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
    import config from '@/Config'
export default {
  created() {
    this.getBreadcrumb()
  },
  data() {
    return {
      levelList: null,
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  methods: {
    getBreadcrumb() {
      // let matched = this.$route.matched.filter(item => item.name)
      // const first = matched[0]
      // if (first && first.name !== 'home') {
      //   matched = [{ path: '/datas/summary', meta: { title: '汇总数据' }}].concat(matched)
      // }
      this.levelList = this.$route.matched;
      if (this.levelList[this.levelList.length - 1].parent.meta.insideURL) {
          document.title = `${this.levelList[this.levelList.length - 1].parent.meta.title} - ${config.name}共享充电宝控制台`;
      } else {
          document.title = `${this.levelList[this.levelList.length - 1].meta.title} - ${config.name}共享充电宝控制台`;
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    line-height: 50px;
    margin-left: 10px;
    .no-redirect {
      color: #97a8be;
      cursor: text;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue